import styled from 'styled-components';
import { Flex, Box } from '@chakra-ui/react';

export const ContentCharts = styled(Flex)`
  /* border: 1px solid red; */
  height: 100%;
`;

export const DotFineshed = styled.div`
  height: 10px;
  width: 10px;
  background-color: ${({ theme }) => theme.colors['secondary']};
  margin-right: 0.5rem;
  border-radius: 50%;
  display: inline-block;
`;

export const DotInProgress = styled.div`
  height: 10px;
  width: 10px;
  background-color: ${({ theme }) => theme.colors['tertiary500']};
  margin-right: 0.5rem;
  border-radius: 50%;
  display: inline-block;
`;

export const DotDisabled = styled.div`
  height: 10px;
  width: 10px;
  background-color: ${({ theme }) => theme.colors['magenta']};
  margin-right: 0.5rem;
  border-radius: 50%;
  display: inline-block;
`;

export const DotLegalAssesment = styled.div`
  height: 10px;
  width: 10px;
  background-color: ${({ theme }) => theme.colors['tangerine100']};
  margin-right: 0.5rem;
  border-radius: 50%;
  display: inline-block;
`;

export const BoxChakra = styled(Box)`
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.black700};
  user-select: none;
`;
